import get from 'lodash/get';

const findHighestScoreInTest = (attempts, name) => {
  let score = 0;
  attempts.forEach((attempt) => {
    const namedScore = attempt.scores.find((score) => score.name === name);
    const value = get(namedScore, 'value', 0);
    /* istanbul ignore next */
    score = Math.max(score, value);
  });
  return score;
};

const findHighestScores = (scores, keyScores, name, keyName) => {
  /* istanbul ignore else */
  if (scores) {
    return findHighestScoreInTest(scores.attempts, name);
  }
  if (keyScores && keyName !== '') {
    return findHighestScoreInTest(keyScores.attempts, keyName);
  }
};

export const parseTestScores = (scoreType, name, keyName, testScores) => {
  let score = 0;
  /* istanbul ignore else */
  if (testScores) {
    const scores = testScores.find((testScore) => testScore.testType === scoreType);
    const keyScores = testScores.find((testScore) => testScore.testType === 'KEY');
    score = findHighestScores(scores, keyScores, name, keyName);
  }
  /* istanbul ignore next */
  return score > 0 ? score : undefined;
};

export const getUserSATTotalScore = (applicationStatistics, userData, testScores) => {
  let usePsat = false;
  let sat =
    get(applicationStatistics, 'userInfo.academics.sat', 0) ||
    get(userData, 'highestSAT', 0) ||
    parseTestScores('SAT', 'total', 'sat1600', testScores);
  if (!sat) {
    sat =
      get(applicationStatistics, 'userInfo.academics.psat', 0) ||
      get(userData, 'psat', 0) ||
      parseTestScores('PSAT', 'totalScore', 'value', testScores) ||
      parseTestScores('KEY', 'psat', 'value', testScores);
    usePsat = true;
    if (sat) {
      return { sat, usePsat };
    }
  }
  return { sat, usePsat };
};

export const getStudentProfileState = (userData, highSchool) => {
  return get(userData, 'address.state') || get(highSchool, 'state', '');
};

const getStudentProfileScores = (
  applicationStatistics,
  highSchool,
  userData,
  testScores,
) => {
  const concordanceGpa =
    get(userData, 'gpaConcordance.concordanceGpas.peerDefault', '') ||
    get(userData, 'gpaConcordance.concordanceGpas.mappedDefault', '');

  let gpa = null;
  if (
    concordanceGpa &&
    !Number.isNaN(Number(concordanceGpa)) &&
    Number(concordanceGpa) > 0
  ) {
    gpa = Number(concordanceGpa) <= 4.0 ? Number(concordanceGpa) : 4.0;
  }

  const { sat, usePsat } = getUserSATTotalScore(
    applicationStatistics,
    userData,
    testScores,
  );
  const act = parseTestScores('ACT', 'total', 'act', testScores);
  const state = getStudentProfileState(userData, highSchool);
  const calcRankPerc =
    (Number(get(userData, 'gpaConcordance.concordanceRanks.rank')) /
      Number(get(userData, 'classSize', ''))) *
    100;
  let classRank = calcRankPerc;
  if (calcRankPerc && !Number.isNaN(calcRankPerc)) {
    // Convert classRank to nearest <5% increaments
    const rankPercDelta = calcRankPerc % 5 > 0 ? 1 : 0;
    classRank = (Math.floor(calcRankPerc / 5) + rankPercDelta) * 5;
  } else {
    classRank = null;
  }
  return { gpa, sat: !usePsat ? sat : null, act, classRank, state };
};

export default getStudentProfileScores;
